import { render } from "./Recommendations.vue?vue&type=template&id=e9680b0c&ts=true"
import script from "./Recommendations.vue?vue&type=script&lang=ts"
export * from "./Recommendations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__